import { InlineTagFormView } from '../view/InlineTagFormView';
import { templateInlineTagForm } from '../view/template';
import { BaseWebComponentController, IListenerConfig } from '../../../../framework/BaseWebComponentController';
import { InlineTagFormWebComponent } from '..';
import { ButtonEvents } from '../../../../ui/gzButton/types';
import { ListItemEvents } from '../../../../ui/gzListItem/types';
import { ElementClass, elementClassListAdd, elementClassListRemove } from '../../../../utils/htmlElement.utils';

export class InlineTagFormController extends BaseWebComponentController {
  public component: InlineTagFormWebComponent;
  public view: InlineTagFormView;
  public viewConstructor: typeof InlineTagFormView;

  private addNewTagClicked = false;

  constructor(component: InlineTagFormWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: InlineTagFormView,
      viewTemplate: templateInlineTagForm,
    });
  }

  computeEventListeners(): IListenerConfig[] {
    return [
      {
        element: this.view.dom.$addTagButton,
        event: ButtonEvents.CLICK,
        callback: this.onAddNewTagClick,
      },
      {
        element: this.view.dom.$tagNameListItem,
        event: ListItemEvents.SAVE,
        callback: this.onListItemSave,
      },
      {
        element: this.view.dom.$tagNameListItem,
        event: ListItemEvents.CANCEL,
        callback: this.onListItemCancel,
      },
      {
        element: this.view.dom.$tagNameListItem,
        event: ListItemEvents.CLICK_OUTSIDE,
        callback: this.onListItemClickedOutside,
      },
    ];
  }

  private onAddNewTagClick(event) {
    event.stopPropagation();
    elementClassListAdd(this.view.dom.$addTagButton, ElementClass.HIDDEN);
    elementClassListRemove(this.view.dom.$tagNameListItem, ElementClass.HIDDEN);
    this.view.dom.$tagNameListItem.innerText = '';
    this.view.dom.$tagNameListItem.editable = true;
    this.addNewTagClicked = true;
    this.component.dispatchEvent(
      new CustomEvent('tagButtonInteract', {
        detail: {
          addNewTagClicked: this.addNewTagClicked,
        },
        bubbles: true,
        composed: true,
      })
    );
  }

  private onListItemSave(event) {
    elementClassListRemove(this.view.dom.$addTagButton, ElementClass.HIDDEN);
    elementClassListAdd(this.view.dom.$tagNameListItem, ElementClass.HIDDEN);
    this.addNewTagClicked = false;
    this.component.dispatchEvent(
      new CustomEvent('customTagAdded', {
        detail: {
          tagName: event.detail.value,
        },
        bubbles: true,
        composed: true,
      })
    );
  }

  private onListItemCancel(event) {
    if (event.detail.cancelFromClickOutside) {
      return;
    }
    elementClassListRemove(this.view.dom.$addTagButton, ElementClass.HIDDEN);
    elementClassListAdd(this.view.dom.$tagNameListItem, ElementClass.HIDDEN);
    this.addNewTagClicked = false;
    this.component.dispatchEvent(
      new CustomEvent('tagButtonInteract', {
        detail: {
          addNewTagClicked: this.addNewTagClicked,
        },
        bubbles: true,
        composed: true,
      })
    );
  }

  private onListItemClickedOutside(event) {
    if (this.addNewTagClicked) {
      elementClassListAdd(this.view.dom.$addTagButton, ElementClass.HIDDEN);
      elementClassListRemove(this.view.dom.$tagNameListItem, ElementClass.HIDDEN);
      this.view.dom.$tagNameListItem.editable = true;
    }
  }

  async getDataForView() {
    return {
      minLength: this.component.minLength,
      maxLength: this.component.maxLength,
      customValidators: this.component.customValidators,
    };
  }
}
